/**
 * This is the twofaConfirmationController.
 * @memberOf twofa Module
 * @namespace twofaConfirmationController
 */

/**
 * @name twofaConfirmationController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param $log
 * @param $state
 * @param $window
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */
function twofaConfirmationController($scope, $translate, coreService, $log, $state, $window) {
    // Assign this controller as the view-model.
    // It will be accessible as 'twofaConfirmationController' within the HTML template.
    
    var vm = this;
  
    //properties
    vm.has_errors = false;
    vm.errorMessage= '';

    //method
    vm.continueButtonOnBlur = continueButtonOnBlur;

    // Activate the controller.
    activate();
  
    // Activates the controller.
    function activate() {
  
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();
        if(model == null || typeof(model.data) === 'undefined'){
            $state.go('error');
        }

        $scope.model = model;
        vm.has_errors = $scope.model.has_errors;
        vm.errorMessage = $scope.model.errorMessage;
        
        //Setup translation    
		let stateCheck = setInterval(() => {
            if ($window.document.readyState === 'complete') {

              clearInterval(stateCheck);              
              $translate(['twofa.confirmation.remember_me.form.header', 'twofa.confirmation.remember_me.form.message_line_1', 'twofa.confirmation.remember_me.form.message_line_2',
                          'twofa.confirmation.remember_me.form.continue_button']) 
              .then(function(data) {
                  vm.data = data; 
                  setAriaLabelOnLoad(true, 'btnContinue');
                  setFocus("btnContinue");   
              });
              
            }
        }, 0);
    }
    
    function continueButtonOnBlur(e) {
        setAriaLabelOnLoad(false, 'btnContinue');
    }

    function setFocus(id)
    {
        var element = $window.document.getElementById(id);
        if(typeof(element) != 'undefined' && element != null)
        {
            $window.setTimeout(function(){ element.focus(); }, 0);
        }      
    }

    function setAriaLabelOnLoad(enable, id)
    {
        var element = document.getElementById(id);
        if(typeof(element) != 'undefined' && element != null)
        {
            var arialDescriptionText = vm.data['twofa.confirmation.remember_me.form.continue_button'];
            if (enable)
            {
                var arialDescriptionText = vm.data['twofa.confirmation.remember_me.form.header'] + '. ' 
                                            + vm.data['twofa.confirmation.remember_me.form.message_line_1']
                                            + vm.data['twofa.confirmation.remember_me.form.message_line_2']
                                            + vm.data['twofa.confirmation.remember_me.form.continue_button']; 
            }
            
            element.setAttribute('aria-label', arialDescriptionText);
        }
    }
 
  }
  
  export default twofaConfirmationController;


// WEBPACK FOOTER //
// ./src/login/2fa/confirmation/2fa.confirmation.controller.js